export default __webpack_public_path__ + "static/media/King Conan's Tribute.331c2c60.jpg";